import {
  faGithub,
  faLinkedin,
  // faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { NavLink, BrowserRouter as Router, useLocation } from "react-router-dom";
import AnimatedRoutes from "../../Routes/AnimatedRoutes";
import en from "../../assets/images/en.png";
import it from "../../assets/images/it.png";
import { Context } from "../../context";
import OpenTerminal from "../Terminal/OpenTerminal";
import classes from "./Header.module.css";

const HeaderNavigation = () => {
  const location = useLocation();
  const isCloudPlayerDemo = location.pathname === "/experiments/cloud-player";
  const isCv = location.pathname === "/cv";

  const dataItem = JSON.parse(localStorage.getItem("nav"));
  const [navClass, setNavClass] = useState("bg-transparent");
  const {
    debug,
    lang,
    setLang,
    linkedin,
    youtube,
    github,
    terminal,
    setTerminal,
    setViewMode,
  } = useContext(Context);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const savedLang = localStorage.getItem("language");
    if (savedLang) {
      setLang(savedLang);
      setIsChecked(savedLang === "it");
    }
  }, []);

  const handleSwitchChange = () => {
    setIsChecked(!isChecked);
    if (isChecked) {
      setLang("en");
      localStorage.setItem("language", "en");
    } else {
      setLang("it");
      localStorage.setItem("language", "it");
    }
  };

  if (debug) {
    console.log("render header");
  }

  const switchStyle = {
    marginTop: "-2px",
    marginLeft: "6px",
    width: "40px",
  };

  const closeMenu = () => {
    const menu = document.getElementById("header-nav");
    if (menu) {
      const bsCollapse = new window.bootstrap.Collapse(menu, {
        toggle: false,
      });
      bsCollapse.hide();
    }
  };

  if (isCloudPlayerDemo || isCv) {
    return null;
  }

  return (
    <header id="header" className="sticky-top-slide">
      <nav
        className={`${classes.ScrollBg} primary-menu navbar navbar-expand-lg bg-transparent navbar-dark border-bottom-0`}
      >
        <div className="container-fluid position-relative g-lg-4">
          <div className="col-auto col-lg-2">
            <a href="/">
              <img
                src="/assets/images/logo_white.png"
                alt="Davide Balice"
                className={classes.logo_header}
              />
            </a>
          </div>
          <div className="col col-lg-8 navbar-accordion">
            <button
              className="navbar-toggler ms-auto"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#header-nav"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <div
              id="header-nav"
              className="collapse navbar-collapse justify-content-center"
            >
              <ul className="navbar-nav">
                <li className={classes.navLink}>
                  <NavLink
                    to="/"
                    onClick={() => {
                      closeMenu();
                    }}
                    className="nav-link nav-link-mobile smooth-scroll"
                  >
                    Home
                  </NavLink>
                </li>

                <li className={classes.navLink}>
                  <NavLink
                    to="/about-me"
                    className="nav-link nav-link-mobile smooth-scroll"
                    onClick={() => {
                      closeMenu();
                    }}
                  >
                    {lang === "en" ? "About me" : "Chi sono"}
                  </NavLink>
                </li>

                <li className={classes.navLink}>
                  <NavLink
                    to="/skill"
                    onClick={() => {
                      closeMenu();
                    }}
                    className="nav-link nav-link-mobile smooth-scroll"
                  >
                    Skills
                  </NavLink>
                </li>

                <li className={classes.navLink}>
                  <NavLink
                    to="/demo"
                    onClick={() => {
                      closeMenu();
                    }}
                    className="nav-link nav-link-mobile smooth-scroll"
                  >
                    Demo & Code
                  </NavLink>
                </li>

                <li className={classes.navLink}>
                  <NavLink
                    to="/project"
                    onClick={() => {
                      closeMenu();
                    }}
                    className="nav-link nav-link-mobile smooth-scroll"
                  >
                    {lang === "en" ? "Projects" : "Progetti"}
                  </NavLink>
                </li>

               
               

                <li className={classes.navLink}>
                  <NavLink
                    to="/experiments"
                    onClick={() => {
                      closeMenu();
                    }}
                    className="nav-link nav-link-mobile smooth-scroll"
                  >
                    Experiments
                  </NavLink>
                </li>

                <li className={classes.navLink}>
                  <NavLink
                    to="/games"
                    onClick={() => {
                      closeMenu();
                    }}
                    className="nav-link nav-link-mobile smooth-scroll"
                  >
                    Games
                  </NavLink>
                </li>

                <li className={classes.navLink}>
                  <NavLink
                    to="/contact"
                    onClick={() => {
                      closeMenu();
                    }}
                    className="nav-link nav-link-mobile smooth-scroll"
                  >
                    {lang === "en" ? "Contact" : "Contatti"}
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-auto col-lg-2 d-flex justify-content-end">
            <Form className={classes.langForm}>
              <img src={en} className={classes.langIcon} alt="en lang" />
              <Form.Switch
                id="custom-switch"
                offlabel=" IT "
                checked={isChecked}
                onChange={handleSwitchChange}
                style={switchStyle}
                className={classes.customSwitch}
              />

              <img src={it} className={classes.langIcon} alt="it lang" />
            </Form>

            <ul
              className={`${classes.socialHeader} social-icons social-icons-light`}
            >
              <li>
                <a
                  className={classes.social}
                  href={linkedin}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faLinkedin}
                    className={classes.socialIcon}
                  />
                </a>
              </li>
              <li>
                <a
                  className={classes.social}
                  href={github}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faGithub}
                    className={classes.socialIcon}
                  />
                </a>
              </li>
              {/* <li>
                <a
                  className={classes.social}
                  href={youtube}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faYoutube}
                    className={classes.socialIcon}
                  />
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

const Header = () => {
  return (
    <Router forceRefresh={false}>
      {/* <OpenTerminal /> */}
      <HeaderNavigation />
      <AnimatedRoutes />
    </Router>
  );
};

export default Header;
